import React, { useEffect, useState } from "react";
import "./ShopItemScreen.css";

//components
import Nav from "../../Components/Nav/Nav";
import Footer from "../../Components/Footer/Footer";
import Carousel from '../../Components/Carousel/Carousel';

//data source
import {
    supplyChairs,
    supplyCabinets,
    supplyDecor,
    supplyTables,
} from "../../Data";
import { useHistory } from "react-router";

//redux.js
import { useDispatch } from "react-redux";
import { addToCart } from '../../feature/cartSlice';


function ShopItemScreen(props) {
        const history = useHistory();

        const dispatch = useDispatch();

        const itemNumber = props.match.params.itemNumber;

        const itemType = props.match.params.itemType;

        const [item, setItem] = useState("");

        const getItem = () => {
            if(!/\d/.test(itemNumber)) history.push('/error');
            else if (itemType === "chairs") {
                if (!supplyChairs[itemNumber - 1]) history.push('/notfound');
                else setItem(supplyChairs[itemNumber - 1]);
            }
            else if (itemType === "tables") {
                if (!supplyTables[itemNumber - 1]) history.push('/notfound');
                else setItem(supplyTables[itemNumber - 1]);
            }
            else if (itemType === "room_decor") {
                if (!supplyDecor[itemNumber - 1]) history.push('/notfound');
                else setItem(supplyDecor[itemNumber - 1]);
            }
            else if (itemType === "cabinets") {
                if (!supplyCabinets[itemNumber - 1]) history.push('/notfound');
                else setItem(supplyCabinets[itemNumber - 1]);
            }
            else history.push('/notfound');
        };

        useEffect(() => {
            
                return getItem();
                
        });

        return (
        <>
            <Nav />
            <div className="shopScreen__item">
                <div className="item__info__container__shop">
                <div className="item__image">
                    <Carousel data={item} />
                    {/* {item.image ? (
                    <img
                        className="item__image__prod"
                        src={item.image}
                        alt={item.name}
                    />
                    ) : (
                    ""
                    )}
                    {item.image2 ? (
                    <img
                        className="item__image__prod"
                        src={item.image2}
                        alt={item.name}
                    />
                    ) : (
                    ""
                    )}
                    {item.image3 ? (
                    <img
                        className="item__image__prod"
                        src={item.image3}
                        alt={item.name}
                    />
                    ) : (
                    ""
                    )} */}
                </div>
                <div className="item__informationOn">
                    <h1>{item.name}</h1>
                    <br />
                    <br />
                    <p style={{ borderBottom: "1px solid black" }}>
                    Price: ${item.price}
                    </p>
                    <br />
                    <p>{item.description}</p>
                    <br />
                    <button onClick={() => dispatch(addToCart(item))} className='item__to__cart__btn' >Click To Add Item To Your Cart</button>
                </div>
                </div>
            </div>
            <Footer />
            </>
        );
}

export default ShopItemScreen;
